/**
 * משותף לעמודי פירוט LDS — ללא העתקת לוגיקה עסקית.
 */

export function extractLdsOrderRowFromFetchResponse(payload) {
  if (!payload || typeof payload !== "object") return null;
  if (payload.id != null || payload.dealid != null) return payload;
  const inner = payload.order ?? payload.data ?? payload.result;
  if (inner && typeof inner === "object" && !Array.isArray(inner) && (inner.id != null || inner.dealid != null)) {
    return inner;
  }
  return null;
}
